import {polygon as polygonFN} from "@turf/helpers";

export default function turfPolygon(coordinates, properties, options) {
    return polygonFN(coordinates, properties, options);
}
